<template>
  <div class="search-box">
    <label class="search-box__label">
      <span class="search-box__icon">
        <font-awesome-icon :icon="['fal', 'search']" />
      </span>

      <input
        class="search-box__input"
        type="text"
        v-model.trim="model"
        v-bind="$attrs"
        :placeholder="placeholder"
        @keyup.enter="handleSearch"
      />
    </label>

    <span v-if="model" class="search-box__clear" @click="clear">
      <font-awesome-icon :icon="['fal', 'times']" />
    </span>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'SearchBox',

  inheritAttrs: false,

  components: {
    FontAwesomeIcon,
  },

  props: {
    id: {
      default: 'generic-search-box',
      type: String,
    },

    placeholder: {
      default: 'filter results',
      type: String,
    },

    value: {
      default: '',
      type: String,
    },
  },

  computed: {
    model: {
      get() {
        return this.value;
      },

      set(value) {
        this.$emit('input', value);
      },
    },
  },

  methods: {
    clear() {
      this.$emit('input', '');
      this.$emit('clear');
      this.handleSearch();
    },

    handleSearch(query) {
      this.$emit('search', query);
    },
  },
};
</script>

<style lang="scss" scoped>
.search-box {
  position: relative;
  width: 100%;
  margin: 0;
  border-radius: 7px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  box-shadow: none;
  transition: box-shadow 0.26s;

  &_focused {
    box-shadow: 0 0 0 1px white inset;
  }

  &__label {
    display: flex;
    align-items: center;
    width: 100%;
    margin: 0;
  }

  &__icon {
    font-size: 18px;
    position: absolute;
    left: 12px;
    top: 50%;
    margin: 0;
    color: $default-text-grey;
    transform: translateY(-50%);
  }

  &__clear {
    font-size: 18px;
    position: absolute;
    right: 16px;
    cursor: pointer;
  }

  &__input {
    font-size: 16px;
    width: 100%;
    height: 44px;
    padding: 8px 36px 8px 44px;
    color: white;
    box-sizing: border-box;
    border-radius: 44px;
    background-color: $default-component-grey;

    &:focus {
      box-shadow: 0 0 0 1px white inset;
    }

    &::-webkit-input-placeholder {
      color: $default-grey;
    }

    &:-ms-input-placeholder {
      color: $default-grey;
    }

    &::-ms-input-placeholder {
      color: $default-grey;
    }
  }
}
</style>
